<template lang="pug">
section#environment
  .container.custom_container_lg
    .row
      breadcrumb
  .container.custom_container_md.custom_container_news_sm
    .row.i_mt_14.i_mt_md_10
      .col-12.text-center.text-lg-left
        h2.title.bottom_line 環境永續
    .row
      .col-12.text-center.text-lg-left.i_mt_10.i_mt_sm_6
        p.i_body_l.i_mt_4.i_mt_sm_6(v-html="environment.area01_Content01")
    .row
      .col-12.text-center.text-lg-left.i_mt_10.i_mt_sm_6
        h4 {{ environment.area01_Title01 }}
        p.i_body_l.i_mt_4.i_mt_sm_6(v-html="environment.area01_Content02")
    .row
      .col-12.text-center.text-lg-left.i_mt_10.i_mt_sm_6
        h4 {{ environment.area01_Title02 }}
        p.i_body_l.i_mt_4.i_mt_sm_6(v-html="environment.area01_Content03")
    .row.i_mt_8
      .col-12.d-flex.flex-wrap.flex-md-nowrap.justify-content-md-center.justify-content-start
        img.img_1(:src="environment.area01_Image01")
        p.earthquake_info(v-html="environment.area01_Imagebrief")
        img.img_2(:src="environment.area01_Image02")
      .col-12.text-left.text-md-center.i_mt_4.i_mt_sm_6 
        span(v-html="environment.area01_ImageMemo")
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb";
import { getEnvironment } from "@/json/about_us";

export default {
  name: "AboutUsSocialResponsibilityEnvironment",
  metaInfo() {
    return {
      title: this.environment.SEO_Title,
      meta: [
        { name: "description", content: this.environment.SEO_Description },
      ],
    };
  },
  components: {
    breadcrumb: Breadcrumb,
  },
  data() {
    return {
      environment: {},
    };
  },
  created() {
    this.getEnvironment();
  },
  methods: {
    getEnvironment() {
      getEnvironment().then((response) => {
        this.environment = response.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/social_responsibility/common";
@import "@/assets/style/about_us/social_responsibility/environment";
</style>
